export default __webpack_public_path__ + "static/media/redesign.4773a83a.png";